<template>
  <div class="filter-container">
    <div class="search-container d-flex flex-column flex-sm-row align-items-start justify-content-sm-between">
      <div class="right-wrapprr w-100 mb-3 mb-sm-0">
        <search-input
          class="search-input"
          type="text"
          v-model="Searched"
          placeholder="Search for filter"
        />
      </div>
      <secondary-button
        @click.native="$router.push({name: 'system-admin-filter-add'})"
        class="secondary-button buyfilter"
      >Add Filter</secondary-button>
    </div>
    <loader :loading="loading" v-if="loading" />
    <template v-else>
      <not-found v-if="isFound" />
      <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th style="min-width: 160px">Text to block</th>
              <th>Company Name</th>
              <th>Vendor Name</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr class="line" v-for="(filter, k) in filters" :key="k">
              <th style="min-width: 160px" class="text-to-block d-flex align-items-center">
                <div
                  class="status"
                  :class="filter.isActive ? 'active' : 'inactive'"
                  @click="changeStatus(filter.textId, filter.isActive)"
                ></div>
                <span>
                  {{filter.text}}
                </span>
              </th>
              <th class="select-container">
                <primary-select type="text" v-if="filter.companies.length !== 0">
                  <option
                    value
                    disabled
                    hidden
                  >{{ filter.companies.length === 1 ? filter.companies.length + ' company selected' : filter.companies.length + ' companies selected'}}</option>
                  <option
                    v-for="(i, company_uuid) in filter.companies"
                    :key="company_uuid"
                  >{{i.company_name}}</option>
                </primary-select>
                <div v-else class="text">All</div>
              </th>
              <th class="select-container">
                <primary-select type="text" v-if="filter.vendors.length !== 0">
                  <option
                    value
                    disabled
                    hidden
                  >{{ filter.vendors.length === 1 ? filter.vendors.length + ' vendor selected' : filter.vendors.length + ' vendors selected'}}</option>
                  <option
                    v-for="(i, vendor_uuid) in filter.vendors"
                    :key="vendor_uuid"
                  >{{i.vendor_name}}</option>
                </primary-select>
                <div v-else class="text">All</div>
              </th>
              <th class="icon action">
                <span title="Edit">
                             <svg
                                     @click="$router.push({name: 'system-admin-filter-edit', params: {id: filter.textId}})"
                                     class="svg-grey"
                                     width="30px"
                                     height="30px"
                                     viewBox="0 0 30 30"
                                     version="1.1"
                             >
                  <path
                          d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                          id="path-1"
                  />
                </svg>
                </span>
                <span title="Delete">
                  <svg
                          @click="deleteFilter(filter.textId)"
                          class="svg-grey delete"
                          width="30px"
                          height="30px"
                          viewBox="0 0 30 30"
                          version="1.1"
                  >
                  <path
                          d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                          id="path-1"
                  />
                </svg>
                </span>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page">
        <span class="filter_by custom-row">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
          </primary-select>
        </div>
      </div>
      <div v-if="!isFound" class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="TotalPages"
          :perPage="per_page"
          :qnt="filters.length"
        />
      </div>
    </template>
    <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden"></div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    types: ["ANI", "DNIS"],
    showDropDown: false,
    filters: [],
    Page: 0,
    Searched: "",
    pages: [10, 50, 100],
    per_page: 10,
    Total: null,
    TotalPages: null,
    company_logo_path: null,
    type: null,
    loading: true,
    isFound: false,
  }),
  created() {
    this.GetList();
  },
  watch: {
    Searched() {
      this.Page = 0;
      this.GetList();
    },
  },
  methods: {
    changeStatus(id, isActive) {
      const filter = { is_active: !isActive };
      this.$store
        .dispatch("EditFilter", { id, filter })
        .then(() => {
          this.$success("Filter status was changed");
          this.GetList();
        })
        .catch((err) => this.$error(err));
    },
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    GetList() {
      this.loading = true;
      this.isFound = false;
      this.$store
        .dispatch("GetFilters", {
          page: this.Page,
          search: this.Searched,
          per_page: this.per_page,
        })
        .then((res) => {
          console.log("res from GetFilters--->", res);
          this.loading = false;
          if (!res.items.length) {
            this.isFound = true;
            return;
          }
          this.filters = res.items.map(this.transformFilters);
          this.per_page = res.per_page;
          this.Total = res.total;
          this.TotalPages = res.total / res.per_page;
        });
    },
    deleteFilter(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this filter!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteFilter", id)
            .then(() => {
              this.$swal({
                title: "Deleted!",
                text: "The Filter has been deleted.",
                type: "success",
              });
              // this.$router.push({
              //   name: "company-admin-campaings-all-campaings"
              // });
              this.GetList();
            })
            .catch((err) => {
              console.log("err=====>", err.response.data);
              this.$snotify.error(err.response.data.errors[0]);
            });
        }
      });
    },
    transformFilters(i, k) {
      let companyName = i.companies.map((i, k) => {
        if (k == 0) {
          return i.company_name;
        }
      });
      let vendorName = i.vendors.map((i, k) => {
        if (k == 0) {
          return i.vendor_name;
        }
      });
      return {
        textId: i.stop_text_uuid,
        text: i.text,
        companies: i.companies,
        vendors: i.vendors,
        isActive: i.is_active,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  padding: 0 20px;
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 15px;
    }
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .filter_by {
      margin-right: 15px;
      color: #55616e;
      font-weight: normal;
      font-family: "Helvetica Neue";
      font-size: 14px;
    }
    .perPage {
      width: 120px;
    }
  }
}
.search-container {
  margin-top: 16px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .right-wrapprr {
    display: flex;
    align-items: center;
    width: fit-content;
    .search-input {
      height: 36px;
      max-width: 345px;
      background-color: #ffffff;
    }
    .selects-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .filter_by {
        height: 40px;
        width: 85px;
        color: #55616e;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        padding: 10px 0 10px 30px;
      }
      .type {
        height: 40px;
        width: 150px;
        margin-bottom: 10px;
        color: #55616e;
        font-weight: normal;
      }
    }
  }
  .secondary-button {
    border-radius: 4px;
    background-color: #51a3f3;
    color: #ffffff;
  }
  .secondary-button.buyfilter {
    height: 40px;
    background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    width: 140px;
    color: #fff;
    border-radius: 4px;
    outline: none;
    border: none;
    font-family: Helvetica Neue;
    font-size: 16px;
    font-weight: 500;
    line-height: 30px;
    text-align: center;
    padding: 5px 20px 5px 20px;
  }
}
table.Invoice_table {
  width: 100%;

  th {
    text-align: center;
  }
  .action {
    width: 100px;
  }
  .text-to-block {
    position: relative;

    .status {
      width: 10px;
      min-width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: .5rem;

      &.active {
        background-color: #24e2b8;
      }
      &.inactive {
        background-color: #d2305b;
      }
    }
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
  padding-right: 5px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
}
tbody th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
  min-width: 70px;
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.img_contaioner {
  padding: 7px 0;
}
th.user_active {
  text-align: left;
  position: relative;
  padding-left: 35px;
}
th.icon {
  float: right;
  padding: 10px 0 7px;
  height: 44px;
  .svg-grey {
    height: 30px;
    width: 30px;
    cursor: pointer;
    fill: #55616e;
  }
  .delete {
    margin-left: 5px;
    // margin-right: 20px;
  }
}
th.select-container {
  padding: 0 40px;
  .text {
    padding-left: 15px;
  }
  .primary-input-container .primary-select-wrapper {
    height: 32px;

    .icon-down {
      background: transparent;
      margin-top: -2px;
    }
  }
}
@media (max-width: 1315px) {
  table.Invoice_table {
    width: 1205px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

